define([
	"./_FrontBack",
	"./PluginFactory"
], function(_FrontBack, PluginFactory) {

	return PluginFactory.declare(_FrontBack, {
		materialIcon: "flip_to_front",
		pluginName: "front",
		title: "CanvasBringToFront"
	});
});
